import { render, staticRenderFns } from "./ReduceDebtDetailsSuccess.vue?vue&type=template&id=a449ae0c&scoped=true&"
import script from "./ReduceDebtDetailsSuccess.vue?vue&type=script&lang=js&"
export * from "./ReduceDebtDetailsSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a449ae0c",
  null
  
)

export default component.exports